const convertExternalBrandToCSS = (externalBrand) => ({
    '--externalBrand-apple-base-default': externalBrand.apple.base.default,
    '--externalBrand-apple-base-action': externalBrand.apple.base.action,
    '--externalBrand-apple-base-active': externalBrand.apple.base.active,
    '--externalBrand-apple-base-active-active': externalBrand.apple.base.activeAction,
    '--externalBrand-apple-text-default': externalBrand.apple.text.default,
    '--externalBrand-apple-text-action': externalBrand.apple.text.action,
    '--externalBrand-apple-text-active': externalBrand.apple.text.active,
    '--externalBrand-apple-text-active-action': externalBrand.apple.text.activeAction,
    '--externalBrand-facebook-base-default': externalBrand.facebook.base.default,
    '--externalBrand-facebook-base-action': externalBrand.facebook.base.action,
    '--externalBrand-facebook-base-active': externalBrand.facebook.base.active,
    '--externalBrand-facebook-base-active-active': externalBrand.facebook.base.activeAction,
    '--externalBrand-facebook-text-default': externalBrand.facebook.text.default,
    '--externalBrand-facebook-text-action': externalBrand.facebook.text.action,
    '--externalBrand-facebook-text-active': externalBrand.facebook.text.active,
    '--externalBrand-facebook-text-active-action': externalBrand.facebook.text.activeAction,
    '--externalBrand-google-base-default': externalBrand.google.base.default,
    '--externalBrand-google-base-action': externalBrand.google.base.action,
    '--externalBrand-google-base-active': externalBrand.google.base.active,
    '--externalBrand-google-base-active-active': externalBrand.google.base.activeAction,
    '--externalBrand-google-text-default': externalBrand.google.text.default,
    '--externalBrand-google-text-action': externalBrand.google.text.action,
    '--externalBrand-google-text-active': externalBrand.google.text.active,
    '--externalBrand-google-text-active-action': externalBrand.google.text.activeAction,
    '--externalBrand-snapchat-base-default': externalBrand.snapchat.base.default,
    '--externalBrand-snapchat-base-action': externalBrand.snapchat.base.action,
    '--externalBrand-snapchat-base-active': externalBrand.snapchat.base.active,
    '--externalBrand-snapchat-base-active-active': externalBrand.snapchat.base.activeAction,
    '--externalBrand-snapchat-text-default': externalBrand.snapchat.text.default,
    '--externalBrand-snapchat-text-action': externalBrand.snapchat.text.action,
    '--externalBrand-snapchat-text-active': externalBrand.snapchat.text.active,
    '--externalBrand-snapchat-text-active-action': externalBrand.snapchat.text.activeAction,
    '--externalBrand-kakao-base-default': externalBrand.kakao.base.default,
    '--externalBrand-kakao-base-action': externalBrand.kakao.base.action,
    '--externalBrand-kakao-base-active': externalBrand.kakao.base.active,
    '--externalBrand-kakao-base-active-active': externalBrand.kakao.base.activeAction,
    '--externalBrand-kakao-text-default': externalBrand.kakao.text.default,
    '--externalBrand-kakao-text-action': externalBrand.kakao.text.action,
    '--externalBrand-kakao-text-active': externalBrand.kakao.text.active,
    '--externalBrand-kakao-text-active-action': externalBrand.kakao.text.activeAction,
    '--externalBrand-line-base-default': externalBrand.line.base.default,
    '--externalBrand-line-base-action': externalBrand.line.base.action,
    '--externalBrand-line-base-active': externalBrand.line.base.active,
    '--externalBrand-line-base-active-active': externalBrand.line.base.activeAction,
    '--externalBrand-line-text-default': externalBrand.line.text.default,
    '--externalBrand-line-text-action': externalBrand.line.text.action,
    '--externalBrand-line-text-active': externalBrand.line.text.active,
    '--externalBrand-line-text-active-action': externalBrand.line.text.activeAction,
});
const convertExternalBrandToObject = (externalBrand) => ({
    externalBrandAppleBaseDefault: externalBrand.apple.base.default,
    externalBrandAppleBaseAction: externalBrand.apple.base.action,
    externalBrandAppleBaseActive: externalBrand.apple.base.active,
    externalBrandAppleBaseActiveActive: externalBrand.apple.base.activeAction,
    externalBrandAppleTextDefault: externalBrand.apple.text.default,
    externalBrandAppleTextAction: externalBrand.apple.text.action,
    externalBrandAppleTextActive: externalBrand.apple.text.active,
    externalBrandAppleTextActiveAction: externalBrand.apple.text.activeAction,
    externalBrandFacebookBaseDefault: externalBrand.facebook.base.default,
    externalBrandFacebookBaseAction: externalBrand.facebook.base.action,
    externalBrandFacebookBaseActive: externalBrand.facebook.base.active,
    externalBrandFacebookBaseActiveActive: externalBrand.facebook.base.activeAction,
    externalBrandFacebookTextDefault: externalBrand.facebook.text.default,
    externalBrandFacebookTextAction: externalBrand.facebook.text.action,
    externalBrandFacebookTextActive: externalBrand.facebook.text.active,
    externalBrandFacebookTextActiveAction: externalBrand.facebook.text.activeAction,
    externalBrandGoogleBaseDefault: externalBrand.google.base.default,
    externalBrandGoogleBaseAction: externalBrand.google.base.action,
    externalBrandGoogleBaseActive: externalBrand.google.base.active,
    externalBrandGoogleBaseActiveActive: externalBrand.google.base.activeAction,
    externalBrandGoogleTextDefault: externalBrand.google.text.default,
    externalBrandGoogleTextAction: externalBrand.google.text.action,
    externalBrandGoogleTextActive: externalBrand.google.text.active,
    externalBrandGoogleTextActiveAction: externalBrand.google.text.activeAction,
    externalBrandSnapchatBaseDefault: externalBrand.snapchat.base.default,
    externalBrandSnapchatBaseAction: externalBrand.snapchat.base.action,
    externalBrandSnapchatBaseActive: externalBrand.snapchat.base.active,
    externalBrandSnapchatBaseActiveActive: externalBrand.snapchat.base.activeAction,
    externalBrandSnapchatTextDefault: externalBrand.snapchat.text.default,
    externalBrandSnapchatTextAction: externalBrand.snapchat.text.action,
    externalBrandSnapchatTextActive: externalBrand.snapchat.text.active,
    externalBrandSnapchatTextActiveAction: externalBrand.snapchat.text.activeAction,
    externalBrandKakaoBaseDefault: externalBrand.kakao.base.default,
    externalBrandKakaoBaseAction: externalBrand.kakao.base.action,
    externalBrandKakaoBaseActive: externalBrand.kakao.base.active,
    externalBrandKakaoBaseActiveActive: externalBrand.kakao.base.activeAction,
    externalBrandKakaoTextDefault: externalBrand.kakao.text.default,
    externalBrandKakaoTextAction: externalBrand.kakao.text.action,
    externalBrandKakaoTextActive: externalBrand.kakao.text.active,
    externalBrandKakaoTextActiveAction: externalBrand.kakao.text.activeAction,
    externalBrandLineBaseDefault: externalBrand.line.base.default,
    externalBrandLineBaseAction: externalBrand.line.base.action,
    externalBrandLineBaseActive: externalBrand.line.base.active,
    externalBrandLineBaseActiveActive: externalBrand.line.base.activeAction,
    externalBrandLineTextDefault: externalBrand.line.text.default,
    externalBrandLineTextAction: externalBrand.line.text.action,
    externalBrandLineTextActive: externalBrand.line.text.active,
    externalBrandLineTextActiveAction: externalBrand.line.text.activeAction,
});
const ExternalBrand = {
    apple: {
        base: {
            default: 'var(--externalBrand-apple-base-default)',
            action: 'var(--externalBrand-apple-base-action)',
            active: 'var(--externalBrand-apple-base-active)',
            activeAction: 'var(--externalBrand-apple-base-active-action)',
        },
        text: {
            default: 'var(--externalBrand-apple-text-default)',
            action: 'var(--externalBrand-apple-text-action)',
            active: 'var(--externalBrand-apple-text-active)',
            activeAction: 'var(--externalBrand-apple-text-active-action)',
        },
    },
    facebook: {
        base: {
            default: 'var(--externalBrand-facebook-base-default)',
            action: 'var(--externalBrand-facebook-base-action)',
            active: 'var(--externalBrand-facebook-base-active)',
            activeAction: 'var(--externalBrand-facebook-base-active-action)',
        },
        text: {
            default: 'var(--externalBrand-facebook-text-default)',
            action: 'var(--externalBrand-facebook-text-action)',
            active: 'var(--externalBrand-facebook-text-active)',
            activeAction: 'var(--externalBrand-facebook-text-active-action)',
        },
    },
    google: {
        base: {
            default: 'var(--externalBrand-google-base-default)',
            action: 'var(--externalBrand-google-base-action)',
            active: 'var(--externalBrand-google-base-active)',
            activeAction: 'var(--externalBrand-google-base-active-action)',
        },
        text: {
            default: 'var(--externalBrand-google-text-default)',
            action: 'var(--externalBrand-google-text-action)',
            active: 'var(--externalBrand-google-text-active)',
            activeAction: 'var(--externalBrand-google-text-active-action)',
        },
    },
    snapchat: {
        base: {
            default: 'var(--externalBrand-snapchat-base-default)',
            action: 'var(--externalBrand-snapchat-base-action)',
            active: 'var(--externalBrand-snapchat-base-active)',
            activeAction: 'var(--externalBrand-snapchat-base-active-action)',
        },
        text: {
            default: 'var(--externalBrand-snapchat-text-default)',
            action: 'var(--externalBrand-snapchat-text-action)',
            active: 'var(--externalBrand-snapchat-text-active)',
            activeAction: 'var(--externalBrand-snapchat-text-active-action)',
        },
    },
    kakao: {
        base: {
            default: 'var(--externalBrand-kakao-base-default)',
            action: 'var(--externalBrand-kakao-base-action)',
            active: 'var(--externalBrand-kakao-base-active)',
            activeAction: 'var(--externalBrand-kakao-base-active-action)',
        },
        text: {
            default: 'var(--externalBrand-kakao-text-default)',
            action: 'var(--externalBrand-kakao-text-action)',
            active: 'var(--externalBrand-kakao-text-active)',
            activeAction: 'var(--externalBrand-kakao-text-active-action)',
        },
    },
    line: {
        base: {
            default: 'var(--externalBrand-line-base-default)',
            action: 'var(--externalBrand-line-base-action)',
            active: 'var(--externalBrand-line-base-active)',
            activeAction: 'var(--externalBrand-line-base-active-action)',
        },
        text: {
            default: 'var(--externalBrand-line-text-default)',
            action: 'var(--externalBrand-line-text-action)',
            active: 'var(--externalBrand-line-text-active)',
            activeAction: 'var(--externalBrand-line-text-active-action)',
        },
    },
};

export { ExternalBrand, convertExternalBrandToCSS, convertExternalBrandToObject };
